import React, { useEffect, useContext, useRef, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Grid, Paper, Typography, } from "@mui/material";
import ApiService from "../../functions/apiService";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import ManagementHeaderNav from "../../components/HeadersNav/ManagementHeaderNav";
import { formateDate } from "../../utils/helperFunctions";
import { getGridStringOperators } from "@mui/x-data-grid";
import StatusInTable from "../../components/StatusInTable/StatusInTable";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import EmptyState from "../../components/Error/EmptyState";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { toast } from 'react-toastify';

const CheckboxRenderer = ({
	row,
	setRowSelectionModel,
	setSelectedShift,
	selectedPatch,
	setSelectedPatch,
	rowSelectionModel,
	rowsAll,
}) => {
	const checked = rowSelectionModel.includes(row.id);

	const allRows = Object.values(rowsAll).flat();
	const hasNullBatchSelected = rowSelectionModel.some((id) => {
		const selectedRow = allRows.find((r) => r.id === id);
		return selectedRow && selectedRow.Batch_number == null;
	});

	const handleCheckboxChange = (event) => {
		const isChecked = event.target.checked;

		if (isChecked) {
			setSelectedShift(row.Shift_Code);

			if (row.Batch_number != null) {
				const batchRows = allRows.filter(
					(r) => r.Batch_number === row.Batch_number
				);
				setRowSelectionModel((prev) =>
					Array.from(new Set([...prev, ...batchRows.map((r) => r.id)]))
				);
			} else {
				setRowSelectionModel((prev) => Array.from(new Set([...prev, row.id])));
			}

			if (row.Batch_number != null) {
				setSelectedPatch(row.Batch_number);
			}
		} else {
			if (row.Batch_number != null) {
				const batchRows = allRows.filter(
					(r) => r.Batch_number === row.Batch_number
				);
				setRowSelectionModel((prev) =>
					prev.filter((id) => !batchRows.some((r) => r.id === id))
				);
			} else {
				setRowSelectionModel((prev) => prev.filter((id) => id !== row.id));
			}

			setRowSelectionModel((prev) => {
				if (prev.length === 0) {
					setSelectedShift(null);
					setSelectedPatch(null);
				}
				return prev;
			});
		}
	};

	if (hasNullBatchSelected && row.Batch_number != null) {
		return null;
	}

	return (
		<Checkbox
			color="primary"
			checked={checked}
			onChange={handleCheckboxChange}
		/>
	);
	return null;
};

export default function FillPositions() {
	const { user } = useContext(AuthContext);
	const [loading, setLoading] = useState(true);
	const [submiting, setSubmiting] = useState(false);
	const [rows, setRows] = useState([]);
	const [error, serError] = useState('');
	const [rowSelectionModel, setRowSelectionModel] = useState([]);
	const [viewJobs, setViewJobs] = useState(false);
	const [viewJobsEmp, setViewJobsEmp] = useState([]);
	const [ProgressValue, setProgressValue] = useState(0);
	const [selectedShift, setSelectedShift] = useState();
	const [selectedPatch, setSelectedPatch] = useState(null);
	const [patchId, setPatchId] = useState('');
	const [backMode, setBackMode] = useState(true);
	const [fromPreAccept, setFromPreAccept] = useState(false);
	const [returnbatches, setReturnbatches] = useState([]);
	const intervalId = useRef(null);
	const [expandAll, setExpandAll] = useState(true);
	const [anyExpanded, setAnyExpanded] = useState(true);
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const navigate = useNavigate();
	const [allowedVars, setAllowedVars] = useState({})
	const [timerType, setTimerType] = useState('Seconds');
	const [timer, setTimer] = useState(5);

	let getAllowedVars = () => {
		ApiService.get('/v3Variables')
			.then((res) => {
				setAllowedVars(res?.data?.data)
			}).catch(({ error }) => {
				console.log('error', error)
			});
	}

	useEffect(() => {
		getAllowedVars();
	}, [])

	// useEffect(() => {
	// 	if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS) {
	// 		if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS >= 60) {
	// 			setTimerType('Minutes')
	// 			if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 60) {
	// 				setTimer(1);
	// 			} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 120) {
	// 				setTimer(2);
	// 			} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 180) {
	// 				setTimer(3);
	// 			} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 240) {
	// 				setTimer(4);
	// 			} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 300) {
	// 				setTimer(5);
	// 			} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 360) {
	// 				setTimer(6);
	// 			} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 420) {
	// 				setTimer(7);
	// 			} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 480) {
	// 				setTimer(8);
	// 			} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 540) {
	// 				setTimer(9);
	// 			} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 600) {
	// 				setTimer(10);
	// 			}
	// 			else {
	// 				setTimerType('Seconds')
	// 				setTimer(parseInt(allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS));
	// 			}
	// 		}
	// 		else {
	// 			setTimerType('Seconds')
	// 			setTimer(parseInt(allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS));
	// 		}
	// 	} else {
	// 		setTimerType('Seconds')
	// 		setTimer(5);
	// 	}
	// }, [allowedVars]);

	useEffect(() => {
		if (timerType == 'Minutes') {
			localStorage.setItem('Timer', JSON.stringify([timer * 60]));
		}
		else {
			localStorage.setItem('Timer', JSON.stringify([timer]));
		}
	}, [timer, timerType]);

	const toggleAllCollapses = () => {
		setExpandAll(prev => !prev);
		if (!expandAll) {
			setAnyExpanded(true);
		}
		else {
			setAnyExpanded(false);
		}
	};

	const handleExpandChange = (isExpanded) => {
		if (isExpanded) {
			setAnyExpanded(true);
		}
		else {
			setAnyExpanded(false);
		}
	};

	let columns = [
		{
			field: 'customCheckbox',
			headerName: '',
			sortable: false,
			width: 50,
			filterable: false,
			renderCell: (params) => {
				if ((selectedShift == null || selectedShift.toString() == params.row.Shift_Code.toString()) && (selectedPatch == null || selectedPatch == params.row.Batch_number)) {
					return <>
						<CheckboxRenderer
							rowsAll={rows}
							setRowSelectionModel={setRowSelectionModel}
							rowSelectionModel={rowSelectionModel}
							setSelectedShift={setSelectedShift}
							selectedPatch={selectedPatch}
							setSelectedPatch={setSelectedPatch}
							{...params}
						/>
					</>
				}
			}
		},
		{
			field: 'Batch_number', headerName: 'Batch', flex: 1, minWidth: 140, cellClassName: 'space-cutter-class',
			filterable: false,
			renderCell: (params) => <span style={{ fontSize: '14px' }}>{params.value}</span>,
		},
		{
			field: 'Assignment_Name', headerName: 'Assignment Name', flex: 1, minWidth: 120, cellClassName: 'space-cutter-class',
			filterOperators: getGridStringOperators().filter(
				(operator) => operator.value === "contains"
			),
			renderCell: (params) => <span style={{ fontSize: '14px' }}>{params.value}</span>,
		},
		{
			field: 'Position_Name', headerName: 'Position', flex: 1, minWidth: 120, cellClassName: 'space-cutter-class',
			filterOperators: getGridStringOperators().filter(
				(operator) => operator.value === "contains"
			),
			renderCell: (params) => <span style={{ fontSize: '14px' }}>{params.value}</span>,
		},
		{
			field: 'Shift_Code', headerName: 'Shift', flex: 1, minWidth: 100,
			filterable: false,
			renderCell: (params) => {
				return (params?.row?.Shift_Name);
			},
		},
		{
			field: 'StatusText', headerName: 'Status', flex: 1, minWidth: 100,
			filterable: false,
			renderCell: (params) => {
				if (params.row.StatusText) {
					return (<StatusInTable StatusText={params.row.StatusText} StatusColor={params.row.StatusColor} />);
				}
				return <span></span>;
			},
		},
	];

	const getEmployee = (id) => {
		let requestTimer = timer;
		if (timerType == 'Minutes') {
			requestTimer = requestTimer * 60;
		}
		return ApiService.post('/fill-position-notify', {
			Batch_Number: id,
			Timer: requestTimer
		}).then((data) => {
			setLoading(false);
			return data?.batch_id;
		}).catch((error) => {
			setLoading(false);
			throw error;
		});
	};

	let handleSubmit = () => {
		let RequestTimer = timer;
		if (timerType == 'Minutes') {
			RequestTimer = RequestTimer * 60;
		}
		// if (RequestTimer < 5) {
		// 	toast.error('Timer cannot be less than 5 seconds')
		// 	return;
		// }
		setLoading(true);
		setBackMode(true);
		if (Number.isInteger(timer)) {
			if (rowSelectionModel.length > 0) {
				serError('');
				setSubmiting(true);

				let selectedRows = Object.keys(rows)
					.map(dateKey =>
						rows[dateKey]
							.filter(item => rowSelectionModel.includes(item.id))
							.map(item => ({
								Position_Assignment_id: item.Position_Assignment_id,
								Shift_Code: String(item.Shift_Code),
								Shift_Date: item.Shift_Date
							}))
					).flat();

				ApiService.post('/fill-position-start', { "assignmentsData": selectedRows, })
					.then((response) => {
						setLoading(false);
						const data = response.result;
						const batch_id = selectedPatch;
						const batch_id_new = response?.batch_no;
						getEmployee(response?.batch_no).then((jobIdFromApi) => {
							if (!batch_id && jobIdFromApi) {
								navigate(`/firehouse/fill-position-work/${batch_id_new}/${jobIdFromApi}`);
							} else {
								navigate(`/firehouse/fill-position-work/${batch_id}/${jobIdFromApi}`);
							}
						});
						toast.success('Fill Position Started')

						let patchIds = [];
						data.forEach(item_data => {
							if (item_data.message) {
								setFromPreAccept(true);
								setViewJobs(true);
								setViewJobsEmp(item_data.emp);
								setProgressValue(100);
							} else {
								if (item_data.options.emp.length > 0) {
									if (item_data.jobs.length > 0) {
										patchIds.push(item_data.jobs[0]['batchId']);
									}
								}
							}
						});

						setReturnbatches(patchIds)
					}).catch((e) => {
						setLoading(false);
						clearInterval(intervalId.current);
						setProgressValue(100);
						setSubmiting(false);
						setPatchId('');
						// toast.error(e?.data?.message || 'Some error occured')
					});
			} else {
				serError('Must select Shift');
			}
		} else {
			serError('time must be number');
		}
	};

	let loadData = () => {
		setLoading(true);
		ApiService.get('/fill-position-list')
			.then(({ data }) => {
				setRows(data);
				setLoading(false);
			}).catch((e) => {
				setLoading(false);
				toast.error("Error")
			})
	}

	useEffect(() => {
		loadData()
	}, [])

	useEffect(() => {
		if (patchId != '' && backMode) {
			setViewJobs(true);
		}
	}, [patchId, backMode])


	return (
		<>
			<ManagementHeaderNav />
			<Box style={{ marginTop: "1rem" }}>
				<Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
					{!viewJobs &&
						<Grid item xs={12}>
							<Paper className="p-3">
								<Typography variant="h6">Fill Positions</Typography>
								<div className="pt-3">
									<Box>
										<Grid container style={{ display: 'flex', justifyContent: 'space-between' }}>
											<Grid item xs={12} md={6} sx={{ marginTop: isMobile ? '15px' : '' }}>
												<label className="h6 text-black" style={{ fontSize: '14px' }}>Time Interval</label>
												<div style={{ display: isMobile ? '' : 'flex', flexDirection: isMobile ? '' : 'row' }}>
													<div className="input-group" style={{ maxWidth: '160px', marginRight: '10px', maxHeight: '34px', marginTop: '4px' }}>
														<input type="text" className="form-control shadow-none"
															style={{ maxWidth: '60px', fontSize: '12px' }}
															value={timer}
															// onChange={(e) => setTimer(Number(e.target.value))} />
															onChange={(e) => {
																const value = e.target.value;
																if (value === '') {
																	setTimer(0);
																} else if (/^\d+$/.test(value)) {
																	setTimer(Number(value));
																}
															}} />
														<select className="form-select shadow-none" style={{ fontSize: '12px', cursor: 'pointer' }}
															value={timerType}
															onChange={(e) => setTimerType(e.target.value)}>
															<option value="Seconds">Seconds</option>
															<option value="Minutes">Minutes</option>
														</select>
													</div>
													<Box sx={{ marginTop: isMobile ? '10px' : '' }}>
														<Button className='mx-1 my-1' style={{ fontSize: '12px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(10); setTimerType('Minutes') }}>10 min</Button>
														<Button className='mx-1 my-1' style={{ fontSize: '12px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(5); setTimerType('Minutes') }}>5 min</Button>
														<Button className='mx-1 my-1' style={{ fontSize: '12px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(2); setTimerType('Minutes') }}>2 min</Button>
														<Button className='mx-1 my-1' style={{ fontSize: '12px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(1); setTimerType('Seconds') }}>Last Minute</Button>
													</Box>
												</div>
											</Grid>

											<Grid item sm={6} md={2} sx={{ marginTop: '28px' }}>
												<ButtonTheme
													color='primary'
													disabled={submiting || rowSelectionModel.length == 0}
													onClick={handleSubmit}
													className='mx-4'
												>{submiting ? 'Loading....' : 'Fill Position'}
												</ButtonTheme>

												{Object.keys(rows).length >= 1 ? <>
													<Box
														component="img"
														src={anyExpanded ? '/images/collapse.svg' : '/images/expand.svg'}
														alt="Icon"
														onClick={toggleAllCollapses}
														style={{ cursor: 'pointer', width: '22px', height: '22px' }}
													/>
												</> : ''}
											</Grid>
										</Grid>
									</Box>
									<p className="text-danger">{error}</p>
								</div>
							</Paper>
						</Grid>
					}
					<Grid item xs={12}>
						{loading &&
							<Paper className="w-100 d-flex justify-content-center align-items-center py-4"
								style={{ height: '410px' }}>
								<CircularProgress />
								{submiting &&
									<Box className='mx-4'>
										<h6>Please Wait for Processing to Complete</h6>
									</Box>
								}
							</Paper>
						}

						{!loading && !viewJobs &&
							<Paper className="p-3" sx={{ maxWidth: '93vw', overflowX: 'auto', background: '#FFF' }}>
								{Object.keys(rows).length === 0 ?
									<div className='d-flex align-items-center' style={{ height: 380 }}>
										<EmptyState />
									</div> :
									Object.keys(rows).map((dateKey) => (
										<CollapseComponent
											key={dateKey}
											name={formateDate(dateKey)}
											rows={rows[dateKey]}
											columns={columns}
											hideFooter={true}
											useTopFilter={true}
											open={expandAll}
											onExpandChange={handleExpandChange}
											checkboxSelection={false}
										// onRowClick={(row) =>
										//   handleRowClick(
										//     row,
										//     rowSelectionModel,
										//     setRowSelectionModel,
										//     setSelectedShift,
										//     setSelectedPatch,
										//     rows,
										//   )
										// }
										/>
									))}
							</Paper>
						}

						{/* <PositionWork jobId = {jobId}/> */}
					</Grid>
				</Grid>
			</Box>
		</>)
}